<app-card [title]="'user.editUser.labels.personalInfo'" titleSize="large">
    <ng-template #content>
        <div class="input-grid-gaps grid-2col gap-y-6">
            <app-select-input
                id="educationCode"
                label="user.fields.education"
                [form]="form"
                [staticOptions]="educationCodeToEnumOptions"
                valueKey="value"
                [disabled]="!canEdit">
            </app-select-input>

            <app-text-input
                id="fieldOfStudy"
                label="user.fields.fieldOfStudy"
                [form]="form"
                [disabled]="!canEdit">
            </app-text-input>

            <app-text-input
                id="employeeCode"
                label="user.fields.employeeCode"
                [form]="form"
                [disabled]="!canEdit">
            </app-text-input>

            <app-number-input
                id="prevYearsOfExperience"
                label="user.fields.prevYearsOfExperience"
                [form]="form"
                [min]="0"
                [disabled]="!canEdit">
            </app-number-input>

            @if (isDoctor()) {
                <app-text-input
                    id="icpOfDoctor"
                    label="user.fields.icpOfDoctor"
                    [form]="form"
                    [disabled]="!canEdit">
                </app-text-input>

                <app-search-doctor-specialization
                    [form]="form"
                    class="fr-2">
                </app-search-doctor-specialization>
            }
        </div>
    </ng-template>
</app-card>
